import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FiShield, FiChevronDown, FiUsers, FiMessageSquare } from 'react-icons/fi';
import './AdminMenu.css';

export default function AdminMenu({ mobile = false }: { mobile?: boolean }) {
  const { pathname } = useLocation();
  const isAdminRoute = ['/admin/users', '/admin/user-queries'].includes(pathname.replace(/\/+$/, ''));
  const [open, setOpen] = useState(isAdminRoute);
  useEffect(() => { if (isAdminRoute) setOpen(true); }, [pathname, isAdminRoute]);
  const submenuId = mobile ? 'admin-mobile-links' : 'admin-desktop-links';
  return <div className={`admin-navigation ${mobile ? 'admin-navigation-mobile' : ''}`}>
    <button type="button" className={`admin-navigation-toggle ${isAdminRoute ? 'admin-navigation-selected' : ''}`} aria-expanded={open} aria-controls={submenuId} onClick={() => setOpen(value => !value)}>
      <FiShield /><span>Admin</span><FiChevronDown className={open ? 'admin-navigation-chevron-open' : ''} />
    </button>
    {open && <ul id={submenuId} className="admin-navigation-links">
      <li><NavLink to="/admin/users" className={({ isActive }) => isActive ? 'admin-navigation-active' : ''}><FiUsers /><span>User Management</span></NavLink></li>
      <li><NavLink to="/admin/user-queries" className={({ isActive }) => isActive ? 'admin-navigation-active' : ''}><FiMessageSquare /><span>User Queries</span></NavLink></li>
    </ul>}
  </div>;
}
